export function sortAwards(awards = []) {
  const processedObj = {};
  awards.forEach(award => {
    const { mic_year: year } = award;
    if (processedObj[year]) {
      processedObj[year].awards.push(award);
    } else {
      processedObj[year] = {
        awards: [award]
      };
    }
  });
  return Object.keys(processedObj)
    .reverse()
    .map(key => ({
      year: key,
      awards: processedObj[key].awards
    }));
}
